import { useContext, createElement, type FunctionComponent } from 'react';
// @ts-ignore untyped JS module
import { classNameFix, getPassThroughProps, getValue } from './utils';
import { I18nHMRContext } from '../internal/i18n-internal';

const DEFAULT_OPTIONS = {};

export interface FormattedMessageProps {
  message: string;
  className?: string;
  options?: object;
  useGap?: boolean;
}

function FormattedMessage({
  useGap = false,
  message,
  options = DEFAULT_OPTIONS,
  ...rest
}: FormattedMessageProps) {
  useContext(I18nHMRContext);

  const props = classNameFix(
    getPassThroughProps({ useGap, message, options, ...rest })
  );

  return createElement(
    'i18n-string',
    props,
    getValue({ useGap, message, options }, true)
  );
}

FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.isI18nElement = true;

// Consumers spyOn() this function and we don't want to require the mock to have `displayName`, and `isI18nElement`
export default FormattedMessage as FunctionComponent<FormattedMessageProps>;
